import * as PropTypes from 'prop-types';
import * as React from 'react';

export interface IComponentStateContext
{
    isParentHovered:boolean;
    isParentActive:boolean;
    isParentActiveEventPropagationEnabled:boolean;
}

export const componentStateContextTypes = {
    isParentHovered: PropTypes.bool,
    isParentActive: PropTypes.bool,
    isParentActiveEventPropagationEnabled: PropTypes.bool
};

export abstract class BaseComponentWithStateContext<PropsType, StateType = any> extends React.Component<PropsType, StateType>
{
    public static contextTypes = componentStateContextTypes;

    public context:IComponentStateContext;
}
